export default {
  setProperty(state, { property, payload }) {
    state[property] = payload;
  },
};
